export default "__VITE_ASSET__6939b58e__"